import React from "react";
import "./ReadReport.css";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../../shared/Navbar";
import Swal from "sweetalert2";

const ReadReport = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Get the data passed via navigate
  const {
    RecieptNo,
    Name,
    AccountNo,
    AccountType,
    Recieved,
    PresentBalance,
    Phone,
    agentUserName,
    firstName,
  } = location.state || {};
  console.log("ReadReport data:", {
    RecieptNo,
    Name,
    AccountNo,
    AccountType,
    Recieved,
    PresentBalance,
    Phone,
    agentUserName,
    firstName,
  });

  const sendSMS = async () => {
    if (!Recieved || !AccountNo || !Name) {
      await Swal.fire({
        icon: 'error',
        title: 'Missing Information',
        text: 'Please enter Account No and received Value',
        confirmButtonColor: '#3085d6',
      });
    } else {
      navigate("/Sms", {
        state: {
          firstName,
          Name,
          AccountNo,
          AccountType,
          Recieved,
          PresentBalance,
          Phone,
          agentUserName,
        }
      });
    }
  };

  // const goPrint = async () => {
  //   await Swal.fire({
  //     icon: 'info',
  //     title: 'Print Functionality',
  //     text: 'Print functionality is in progress.',
  //     confirmButtonColor: '#3085d6',
  //   });
  // };

  const goPrint = () => {
  navigate("/BluetoothTest", {
    state: {
      Name: Name || "",
      AccountNo: AccountNo || "",
      AccountType: AccountType || "",
      Recieved: Recieved || "0",
      PresentBalance: PresentBalance || "0",
      Phone: Phone || ""
    }
  });
};

  const goHome = async () => {
    const result = await Swal.fire({
      title: 'Confirm Navigation',
      text: 'Are you sure you want to go to Home screen?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, go to Home',
      cancelButtonText: 'Cancel'
    });
    
    if (result.isConfirmed) {
      navigate("/Home");
    }
  };

  const goBack = async () => {
    const result = await Swal.fire({
      title: 'Confirm Navigation',
      text: 'Are you sure you want to go back to Report screen?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, go back',
      cancelButtonText: 'Cancel'
    });
    
    if (result.isConfirmed) {
      navigate("/Report");
    }
  };

  return (
    <div>
      <Navbar />
   
    <div className="ReadReport-container">
      <div className="ReadReport-bigCircle"></div>
      <div className="ReadReport-smallCircle"></div>

      <div className="ReadReport-centerizedView">
        <div className="ReadReport-authBox">
          <div className="ReadReport-tableContainer">
            {[
              { label: "Reciept No", value: RecieptNo },
              { label: "Account No", value: AccountNo },
              { label: "Account Type", value: AccountType },
              { label: "Name", value: Name },
              { label: "Recieved", value: Recieved },
              { label: "Present Balance", value: PresentBalance },
              { label: "Mobile", value: Phone },
              { label: "Agent Name", value: firstName },
            ].map((item, index) => (
              <div className="ReadReport-row" key={index}>
                <div className="ReadReport-label">{item.label}</div>
                <div className="ReadReport-value">{item.value}</div>
              </div>
            ))}

           <div className="ReadReport-button-row">
             <button className="ReadReport-blueButton" onClick={sendSMS}>
               SMS
             </button>
             <button className="ReadReport-pinkButton" onClick={goPrint}>
               PRINT
             </button>
             <button className="ReadReport-blueButton" onClick={goHome}>
               Home
             </button>
             <button className="ReadReport-pinkButton" onClick={goBack}>
               Back
             </button>
           </div>

          </div>
        </div>
      </div>
    </div>
     </div>
  );
};

export default ReadReport;